import { ReactNode } from 'react';
import { BottomNavigation, BottomNavigationAction, Box, Link } from '@mui/material';
import { Email, Facebook, Instagram, Phone, WhatsApp } from '@mui/icons-material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { anchoMax, datosTeatro } from '../../../utils/constants';
import { theme } from '../../../theme/theme';
import LogoBlanco from 'assets/logo/LogoBoschBlanco.png';
import Typography from '@mui/material/Typography';
import { NavLink, useLocation } from 'react-router-dom';
import { crearUrlWhatsApp, esRutaInformativaWhatsApp } from '../BotonWhatsApp/whatsapp';
import './Footer.scss';

interface ElementoFooter {
  label: string;
  icono: ReactNode;
  value?: string;
}

const informacionTeatro: ElementoFooter[] = [
  {
    label: `${datosTeatro.nombre} - ${datosTeatro.direccion}`,
    icono: <LocationOnIcon />,
  },
  {
    label: `Tel. (+598) ${datosTeatro.celular}`,
    icono: <Phone />,
  },
  {
    label: datosTeatro.email,
    icono: <Email />,
    value: datosTeatro.email,
  },
  {
    label: datosTeatro.cpCiudad,
    icono: <Email />,
  },
];

const Footer = () => {
  const { pathname } = useLocation();
  const redesSociales: ElementoFooter[] = [
    {
      label: 'Instagram',
      icono: <Instagram />,
      value: datosTeatro.instagram,
    },
    ...(esRutaInformativaWhatsApp(pathname)
      ? [
          {
            label: 'WhatsApp',
            icono: <WhatsApp />,
            value: crearUrlWhatsApp(),
          },
        ]
      : []),
    {
      label: 'Facebook',
      icono: <Facebook />,
      value: datosTeatro.facebook,
    },
  ];

  return (
    // Sección boletín
    <Box
      sx={{
        backgroundColor: theme.palette.secondary.dark,
        position: 'absolute',
        bottom: 0,
        width: '100%',
        pt: { xs: 2, sm: 2, md: 0, lg: 4 },
        pb: { xs: '140px', md: 0 },
        mb: { xs: '-180px', md: 0 },
      }}
      className="seccionBoletin"
    >
      {/* Sección footer */}
      <Box
        maxWidth={anchoMax}
        className="footer"
        display="flex"
        justifyContent="space-between"
        margin="auto"
        alignItems={{ xs: 'center', md: 'end' }}
        width="100%"
        sx={{ flexDirection: { xs: 'column', md: 'row' } }}
      >
        {/* Sección izquierda */}
        <Box ml={{ lg: 2, xl: 0 }} margin={{ xs: 'auto', sm: 'unset' }}>
          <Box display={{ xs: 'none', md: 'block' }}>
            {informacionTeatro.map((info: ElementoFooter) => (
              <Typography
                key={info.label}
                lineHeight="2"
                textAlign="left"
                color={theme.palette.primary.contrastText}
                maxWidth={{ xs: '300px', sm: 'unset' }}
              >
                {info.label}
              </Typography>
            ))}
          </Box>
          <BottomNavigation
            onChange={(_, value: string) => {
              const url = redesSociales[Number(value)].value;
              window.open(url, '_blank', 'noopener,noreferrer');
            }}
            sx={{
              backgroundColor: theme.palette.secondary.dark,
              margin: { xs: 0, md: '10px 0 0 -22px' },
              width: { xs: '100%', md: '50px' },
              justifyContent: 'flex-start',
            }}
          >
            {redesSociales.map(({ label, icono }: ElementoFooter) => (
              <BottomNavigationAction
                key={label}
                label={label}
                icon={icono}
                sx={{ color: theme.palette.secondary.main, paddingLeft: 0 }}
              />
            ))}
          </BottomNavigation>
        </Box>

        {/* Sección derecha */}
        <Box
          pr={{ md: 4 }}
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
          mb={{ xs: '-117px', sm: '0' }}
          height={{ sm: '194px' }}
        >
          {/* Logos */}
          <Box height="100px">
            <img src={LogoBlanco} alt="logo teatro bosch" />
          </Box>
          {/* Políticas del sitio */}
          <Box>
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'center', md: 'unset' } }}
            >
              <Link to="/politicas/#privacidad" component={NavLink} underline="none">
                <Typography variant="body2" textAlign="right" lineHeight="2" color={theme.palette.primary.contrastText}>
                  Política de privacidad
                </Typography>
              </Link>
              <Link to="/politicas/#terminos" component={NavLink} underline="none">
                <Typography variant="body2" textAlign="right" lineHeight="2" color={theme.palette.primary.contrastText}>
                  Términos de uso del sitio
                </Typography>
              </Link>
              <Link to="/politicas/#cookies" component={NavLink} underline="none">
                <Typography variant="body2" textAlign="right" lineHeight="2" color={theme.palette.primary.contrastText}>
                  Política de cookies
                </Typography>
              </Link>
            </Box>
            <Typography
              textAlign="right"
              lineHeight="2"
              color={theme.palette.primary.contrastText}
              sx={{
                textAlign: { xs: 'center', md: 'inherit' },
                maxWidth: { xs: '70%', md: 'inherit' },
                marginX: { xs: 'auto', md: 'inherit' },
                marginTop: { xs: 3, md: 'inherit' },
              }}
            >
              <b> © {datosTeatro.nombre}.</b> Todos los derechos reservados.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
